// Liste complète des pays du monde en français
export const COUNTRIES = [
  { value: 'Afghanistan', label: 'Afghanistan' },
  { value: 'Afrique du Sud', label: 'Afrique du Sud' },
  { value: 'Albanie', label: 'Albanie' },
  { value: 'Algérie', label: 'Algérie' },
  { value: 'Allemagne', label: 'Allemagne' },
  { value: 'Andorre', label: 'Andorre' },
  { value: 'Angola', label: 'Angola' },
  { value: 'Anguilla', label: 'Anguilla' },
  { value: 'Antarctique', label: 'Antarctique' },
  { value: 'Antigua-et-Barbuda', label: 'Antigua-et-Barbuda' },
  { value: 'Arabie Saoudite', label: 'Arabie Saoudite' },
  { value: 'Arménie', label: 'Arménie' },
  { value: 'Aruba', label: 'Aruba' },
  { value: 'Australie', label: 'Australie' },
  { value: 'Autriche', label: 'Autriche' },
  { value: 'Azerbaïdjan', label: 'Azerbaïdjan' },
  { value: 'Bahamas', label: 'Bahamas' },
  { value: 'Bahreïn', label: 'Bahreïn' },
  { value: 'Bangladesh', label: 'Bangladesh' },
  { value: 'Barbade', label: 'Barbade' },
  { value: 'Belgique', label: 'Belgique' },
  { value: 'Belize', label: 'Belize' },
  { value: 'Bénin', label: 'Bénin' },
  { value: 'Bermudes', label: 'Bermudes' },
  { value: 'Bhoutan', label: 'Bhoutan' },
  { value: 'Biélorussie', label: 'Biélorussie' },
  { value: 'Birmanie', label: 'Birmanie' },
  { value: 'Bissau-Guinée', label: 'Bissau-Guinée' },
  { value: 'Birmanie/Myanmar', label: 'Birmanie/Myanmar' },
  { value: 'Bolivie', label: 'Bolivie' },
  { value: 'Bosnie-Herzégovine', label: 'Bosnie-Herzégovine' },
  { value: 'Botswana', label: 'Botswana' },
  { value: 'Brésil', label: 'Brésil' },
  { value: 'Brunei', label: 'Brunei' },
  { value: 'Bulgarie', label: 'Bulgarie' },
  { value: 'Burkina Faso', label: 'Burkina Faso' },
  { value: 'Burundi', label: 'Burundi' },
  { value: 'Cambodge', label: 'Cambodge' },
  { value: 'Cameroun', label: 'Cameroun' },
  { value: 'Canada', label: 'Canada' },
  { value: 'Cap-Vert', label: 'Cap-Vert' },
  { value: 'Chili', label: 'Chili' },
  { value: 'Chine', label: 'Chine' },
  { value: 'Chypre', label: 'Chypre' },
  { value: 'Colombie', label: 'Colombie' },
  { value: 'Comores', label: 'Comores' },
  { value: 'Corée du Nord', label: 'Corée du Nord' },
  { value: 'Corée du Sud', label: 'Corée du Sud' },
  { value: 'Costa Rica', label: 'Costa Rica' },
  { value: 'Côte d\'Ivoire', label: 'Côte d\'Ivoire' },
  { value: 'Croatie', label: 'Croatie' },
  { value: 'Cuba', label: 'Cuba' },
  { value: 'Curaçao', label: 'Curaçao' },
  { value: 'Danemark', label: 'Danemark' },
  { value: 'Djibouti', label: 'Djibouti' },
  { value: 'Dominique', label: 'Dominique' },
  { value: 'Égypte', label: 'Égypte' },
  { value: 'Émirats Arabes Unis', label: 'Émirats Arabes Unis' },
  { value: 'Équateur', label: 'Équateur' },
  { value: 'Érythrée', label: 'Érythrée' },
  { value: 'Espagne', label: 'Espagne' },
  { value: 'Estonie', label: 'Estonie' },
  { value: 'États-Unis', label: 'États-Unis' },
  { value: 'Éthiopie', label: 'Éthiopie' },
  { value: 'Fidji', label: 'Fidji' },
  { value: 'Finlande', label: 'Finlande' },
  { value: 'France', label: 'France' },
  { value: 'Gabon', label: 'Gabon' },
  { value: 'Gambie', label: 'Gambie' },
  { value: 'Géorgie', label: 'Géorgie' },
  { value: 'Ghana', label: 'Ghana' },
  { value: 'Gibraltar', label: 'Gibraltar' },
  { value: 'Grèce', label: 'Grèce' },
  { value: 'Grenade', label: 'Grenade' },
  { value: 'Groenland', label: 'Groenland' },
  { value: 'Guadeloupe', label: 'Guadeloupe' },
  { value: 'Guam', label: 'Guam' },
  { value: 'Guatemala', label: 'Guatemala' },
  { value: 'Guernesey', label: 'Guernesey' },
  { value: 'Guinée', label: 'Guinée' },
  { value: 'Guinée équatoriale', label: 'Guinée équatoriale' },
  { value: 'Guyana', label: 'Guyana' },
  { value: 'Guyane française', label: 'Guyane française' },
  { value: 'Haïti', label: 'Haïti' },
  { value: 'Honduras', label: 'Honduras' },
  { value: 'Hong Kong', label: 'Hong Kong' },
  { value: 'Hongrie', label: 'Hongrie' },
  { value: 'Île Bouvet', label: 'Île Bouvet' },
  { value: 'Île Christmas', label: 'Île Christmas' },
  { value: 'Îles Åland', label: 'Îles Åland' },
  { value: 'Îles Caïmans', label: 'Îles Caïmans' },
  { value: 'Îles Cocos', label: 'Îles Cocos' },
  { value: 'Îles Féroé', label: 'Îles Féroé' },
  { value: 'Îles Malouines', label: 'Îles Malouines' },
  { value: 'Îles Mariannes du Nord', label: 'Îles Mariannes du Nord' },
  { value: 'Îles Marshall', label: 'Îles Marshall' },
  { value: 'Îles Pitcairn', label: 'Îles Pitcairn' },
  { value: 'Îles Salomon', label: 'Îles Salomon' },
  { value: 'Îles Turques et Caïques', label: 'Îles Turques et Caïques' },
  { value: 'Îles Vierges britanniques', label: 'Îles Vierges britanniques' },
  { value: 'Îles Vierges des États-Unis', label: 'Îles Vierges des États-Unis' },
  { value: 'Inde', label: 'Inde' },
  { value: 'Indonésie', label: 'Indonésie' },
  { value: 'Irak', label: 'Irak' },
  { value: 'Iran', label: 'Iran' },
  { value: 'Irlande', label: 'Irlande' },
  { value: 'Islande', label: 'Islande' },
  { value: 'Israël', label: 'Israël' },
  { value: 'Italie', label: 'Italie' },
  { value: 'Jamaïque', label: 'Jamaïque' },
  { value: 'Japon', label: 'Japon' },
  { value: 'Jersey', label: 'Jersey' },
  { value: 'Jordanie', label: 'Jordanie' },
  { value: 'Kazakhstan', label: 'Kazakhstan' },
  { value: 'Kenya', label: 'Kenya' },
  { value: 'Kirghizistan', label: 'Kirghizistan' },
  { value: 'Kiribati', label: 'Kiribati' },
  { value: 'Koweït', label: 'Koweït' },
  { value: 'Laos', label: 'Laos' },
  { value: 'Lesotho', label: 'Lesotho' },
  { value: 'Lettonie', label: 'Lettonie' },
  { value: 'Liban', label: 'Liban' },
  { value: 'Liberia', label: 'Liberia' },
  { value: 'Libye', label: 'Libye' },
  { value: 'Liechtenstein', label: 'Liechtenstein' },
  { value: 'Lituanie', label: 'Lituanie' },
  { value: 'Luxembourg', label: 'Luxembourg' },
  { value: 'Macao', label: 'Macao' },
  { value: 'Macédoine', label: 'Macédoine' },
  { value: 'Madagascar', label: 'Madagascar' },
  { value: 'Malaisie', label: 'Malaisie' },
  { value: 'Malawi', label: 'Malawi' },
  { value: 'Maldives', label: 'Maldives' },
  { value: 'Mali', label: 'Mali' },
  { value: 'Malte', label: 'Malte' },
  { value: 'Maroc', label: 'Maroc' },
  { value: 'Martinique', label: 'Martinique' },
  { value: 'Mauritanie', label: 'Mauritanie' },
  { value: 'Maurice', label: 'Maurice' },
  { value: 'Mayotte', label: 'Mayotte' },
  { value: 'Mexique', label: 'Mexique' },
  { value: 'Micronésie', label: 'Micronésie' },
  { value: 'Moldavie', label: 'Moldavie' },
  { value: 'Monaco', label: 'Monaco' },
  { value: 'Mongolie', label: 'Mongolie' },
  { value: 'Monténégro', label: 'Monténégro' },
  { value: 'Montserrat', label: 'Montserrat' },
  { value: 'Mozambique', label: 'Mozambique' },
  { value: 'Namibie', label: 'Namibie' },
  { value: 'Nauru', label: 'Nauru' },
  { value: 'Népal', label: 'Népal' },
  { value: 'Nicaragua', label: 'Nicaragua' },
  { value: 'Niger', label: 'Niger' },
  { value: 'Nigeria', label: 'Nigeria' },
  { value: 'Niue', label: 'Niue' },
  { value: 'Norvège', label: 'Norvège' },
  { value: 'Nouvelle-Calédonie', label: 'Nouvelle-Calédonie' },
  { value: 'Nouvelle-Zélande', label: 'Nouvelle-Zélande' },
  { value: 'Oman', label: 'Oman' },
  { value: 'Ouganda', label: 'Ouganda' },
  { value: 'Ouzbékistan', label: 'Ouzbékistan' },
  { value: 'Pakistan', label: 'Pakistan' },
  { value: 'Palaos', label: 'Palaos' },
  { value: 'Palestine', label: 'Palestine' },
  { value: 'Panama', label: 'Panama' },
  { value: 'Papouasie-Nouvelle-Guinée', label: 'Papouasie-Nouvelle-Guinée' },
  { value: 'Pâques (Île de)', label: 'Pâques (Île de)' },
  { value: 'Paraguay', label: 'Paraguay' },
  { value: 'Pays-Bas', label: 'Pays-Bas' },
  { value: 'Pérou', label: 'Pérou' },
  { value: 'Philippines', label: 'Philippines' },
  { value: 'Pologne', label: 'Pologne' },
  { value: 'Polynésie française', label: 'Polynésie française' },
  { value: 'Porto Rico', label: 'Porto Rico' },
  { value: 'Portugal', label: 'Portugal' },
  { value: 'Qatar', label: 'Qatar' },
  { value: 'La Réunion', label: 'La Réunion' },
  { value: 'République Centrafricaine', label: 'République Centrafricaine' },
  { value: 'République Démocratique du Congo', label: 'République Démocratique du Congo' },
  { value: 'République du Congo', label: 'République du Congo' },
  { value: 'République Dominicaine', label: 'République Dominicaine' },
  { value: 'République Tchèque', label: 'République Tchèque' },
  { value: 'Roumanie', label: 'Roumanie' },
  { value: 'Royaume-Uni', label: 'Royaume-Uni' },
  { value: 'Russie', label: 'Russie' },
  { value: 'Rwanda', label: 'Rwanda' },
  { value: 'Sahara occidental', label: 'Sahara occidental' },
  { value: 'Saint-Barthélemy', label: 'Saint-Barthélemy' },
  { value: 'Saint-Marin', label: 'Saint-Marin' },
  { value: 'Saint-Martin', label: 'Saint-Martin' },
  { value: 'Saint-Pierre-et-Miquelon', label: 'Saint-Pierre-et-Miquelon' },
  { value: 'Saint-Vincent-et-les-Grenadines', label: 'Saint-Vincent-et-les-Grenadines' },
  { value: 'Sainte-Lucie', label: 'Sainte-Lucie' },
  { value: 'Samoa', label: 'Samoa' },
  { value: 'Samoa américaines', label: 'Samoa américaines' },
  { value: 'Samoa occidentales', label: 'Samoa occidentales' },
  { value: 'San Marino', label: 'San Marino' },
  { value: 'Sao Tomé-et-Principe', label: 'Sao Tomé-et-Principe' },
  { value: 'Sénégal', label: 'Sénégal' },
  { value: 'Serbie', label: 'Serbie' },
  { value: 'Seychelles', label: 'Seychelles' },
  { value: 'Sierra Leone', label: 'Sierra Leone' },
  { value: 'Singapour', label: 'Singapour' },
  { value: 'Sint Maarten', label: 'Sint Maarten' },
  { value: 'Slovaquie', label: 'Slovaquie' },
  { value: 'Slovénie', label: 'Slovénie' },
  { value: 'Somalie', label: 'Somalie' },
  { value: 'Somaliland', label: 'Somaliland' },
  { value: 'Soudan', label: 'Soudan' },
  { value: 'Soudan du Sud', label: 'Soudan du Sud' },
  { value: 'Sri Lanka', label: 'Sri Lanka' },
  { value: 'Suède', label: 'Suède' },
  { value: 'Suisse', label: 'Suisse' },
  { value: 'Suriname', label: 'Suriname' },
  { value: 'Svalbard et Jan Mayen', label: 'Svalbard et Jan Mayen' },
  { value: 'Swaziland', label: 'Swaziland' },
  { value: 'Syrie', label: 'Syrie' },
  { value: 'Tadjikistan', label: 'Tadjikistan' },
  { value: 'Taïwan', label: 'Taïwan' },
  { value: 'Tanzanie', label: 'Tanzanie' },
  { value: 'Tchad', label: 'Tchad' },
  { value: 'Terres australes françaises', label: 'Terres australes françaises' },
  { value: 'Thaïlande', label: 'Thaïlande' },
  { value: 'Timor oriental', label: 'Timor oriental' },
  { value: 'Togo', label: 'Togo' },
  { value: 'Tokelau', label: 'Tokelau' },
  { value: 'Tonga', label: 'Tonga' },
  { value: 'Trinité-et-Tobago', label: 'Trinité-et-Tobago' },
  { value: 'Tunisie', label: 'Tunisie' },
  { value: 'Turkménistan', label: 'Turkménistan' },
  { value: 'Turquie', label: 'Turquie' },
  { value: 'Tuvalu', label: 'Tuvalu' },
  { value: 'Ukraine', label: 'Ukraine' },
  { value: 'Uruguay', label: 'Uruguay' },
  { value: 'Vanuatu', label: 'Vanuatu' },
  { value: 'Vatican', label: 'Vatican' },
  { value: 'Venezuela', label: 'Venezuela' },
  { value: 'Viêt Nam', label: 'Viêt Nam' },
  { value: 'Wallis et Futuna', label: 'Wallis et Futuna' },
  { value: 'Yémen', label: 'Yémen' },
  { value: 'Zambie', label: 'Zambie' },
  { value: 'Zimbabwe', label: 'Zimbabwe' },
];
